import React from "react";
import fasterImage from "../../images/faster.svg";
import toolsImage from "../../images/tools.svg";
import serverImage from "../../images/server.svg";

const ReplicatedInfo = props => {
  return (
    <div
      className={`flex flex-1 flex-col items-center self-center mx-auto max-lg:mb-[70px] lg:flex lg:flex-col ${
        props.needsActivation && "hidden md:flex"
      }`}
    >
      <div
        className={`${
          props.needsActivation ? "bg-[url('../../images/activate.svg')] relative bg-[top_center] bg-no-repeat bg-[length:350px] w-[350px] h-[280px]" : "relative bg-[top_center] bg-[url('../../images/global/replicated-logo-red.svg')] bg-no-repeat bg-[length:350px] w-[586px] h-[180px] mt-[70px] max-lg:static max-lg:bg-[length:250px] max-lg:w-full max-lg:h-[100px]"
        }`}
      ></div>
      <div
        className={`block ${
          props.needsActivation ? "hidden" : "feature-list w-[400px]"
        }`}
      >
        <div className="flex feature-list-item mb-[50px]">
          <div className="flex-1 min-h-0 feature-list-icon mr-[30px]">
            <img src={fasterImage} alt="faster time to market" />
          </div>
          <div className="[flex:5]">
            <h2>Faster time to market</h2>
            <p>
              Focus on your product’s core value and let Replicated handle getting it
              delivered to on-prem customers.
            </p>
          </div>
        </div>

        <div className="flex feature-list-item mb-[50px]">
          <div className="flex-1 min-h-0 feature-list-icon mr-[30px]">
            <img src={toolsImage} alt="tools for your entire team" />
          </div>
          <div className="[flex:5]">
            <h2>Tools for your entire team</h2>
            <p>
              Cross-functional collaboration tools that help you deliver modern on-prem
              software to your most important enterprise customers.
            </p>
          </div>
        </div>

        <div className="flex feature-list-item mb-[50px]">
          <div className="flex-1 min-h-0 feature-list-icon mr-[30px]">
            <img src={serverImage} alt="every environment" />
          </div>
          <div className="[flex:5]">
            <h2>Every environment</h2>
            <p>
              Deliver to private clouds (AWS, GCP, Azure), Kubernetes platforms (GKE,
              OpenShift, Rancher), bare metal, and air gap environments with one
              release.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default React.memo(ReplicatedInfo);
